import { createContext, ReactNode, useContext } from "react";

import { SheetDataStore } from "./stores/sheet-data-store";

const SheetDataStoreContext = createContext<SheetDataStore | null>(null);

export const SheetDataStoreProvider = ({
  children,
  store,
}: {
  children: ReactNode;
  store: SheetDataStore;
}) => <SheetDataStoreContext.Provider value={store}>{children}</SheetDataStoreContext.Provider>;

export const useSheetDataStore = (): SheetDataStore => {
  const store = useContext(SheetDataStoreContext);
  if (!store) {
    throw new Error("useSheetDataStore must be used within a <SheetDataStoreProvider>");
  }
  return store;
};

export const useSheetDataStoreSafe = (): SheetDataStore | null => useContext(SheetDataStoreContext);
